import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {getAccessToken} from './authHelper';
import {jsonToCSV} from './utils';
import 'bootstrap/dist/css/bootstrap.min.css';
import './tables.css';
import styles from "./DownloadButton.module.css";
import frameIcon from "./static_files/download.svg";
import Footer from "./footer/Footer";
import Header from "./header/Header";
import trackRecordIcon from "./static_files/Track Records.svg"
import ConnectWalletHeader from "./header/ConnectWalletHeader";
import TrackRecordsCheck from "./TrackRecordsCheck";

const formatDate = (dateString) => {
    const d = new Date(dateString.replace(' GMT', ''));
    const date = new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
    const options = {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    };

    // Format the date without the day of the week
    const formattedDate = date.toLocaleDateString('en-US', options).replace(/,/g, '');
    const formattedTime = date.toLocaleTimeString('it-IT');
    const [month, day, year] = formattedDate.split(' ');

    // Return only the date and time without the day of the week
    return `${day} ${month} ${year} ${formattedTime}`;
};

const formatToPercentage = (value) => {
    return `${(value * 100).toFixed(2)}%`;
};

const formatPercentage = (value) => {
    return `${(value * 1).toFixed(2)}%`;
};
const formatPercentageAPY = (value) => {
    return `${(value * 100).toFixed(2)}%`;
};
const formatToFourDigits = (value) => {
    return parseFloat(value).toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 4})
};
const formatUSDI = (value) => {
    return parseFloat(value).toLocaleString('en-US', {maximumFractionDigits: 4, minimumFractionDigits: 4})
};
const TrackRecords = () => {
    const [data, setData] = useState([]);
    const [initialLoading, setInitialLoading] = useState(true);
    const [remainingLoading, setRemainingLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadPage, setDownloadPage] = useState(0);
    const [downloadTotalPages, setDownloadTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const rowsPerPage = 60;
    const initialChunkSize = 20;
    const chunkSize = 100; // Number of rows to fetch in each subsequent request
    const [showPanel, setShowPanel] = useState(false);

    const fetchInitialTrackRecords = async () => {
        setRemainingLoading(false);
        try {
            const access_token = await getAccessToken();
            console.log("access_token,", access_token)
            const trackRecordsResponse = await axios.get(`https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records?page=1&limit=${initialChunkSize}`, {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            });
            setData(trackRecordsResponse.data.data);
            setInitialLoading(false);
            setTotalPages(Math.ceil(trackRecordsResponse.data.total_records / rowsPerPage));
            fetchRemainingTrackRecordsOfPage1(access_token, 1, initialChunkSize, rowsPerPage - initialChunkSize);

        } catch (error) {
            console.error('Error fetching initial track records:', error);
            setInitialLoading(false);
        }
    };

    const fetchRemainingTrackRecordsOfPage1 = async (access_token, page, offset, limit) => {
        try {
            setRemainingLoading(true);
            const response = await axios.get(`https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records?page=${page}&limit=${limit}&offset=${offset}`, {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            });

            if (response.data && response.data.data && response.data.data.length > 0) {
                setData(prevData => prevData.concat(response.data.data));

                // Continue fetching remaining pages
                fetchRemainingTrackRecords(access_token, 2); // Start fetching remaining data from page 2
            } else {
                setRemainingLoading(false);
            }
        } catch (error) {
            console.error('Error fetching remaining track records:', error);
            setRemainingLoading(false);
        }
    };

    const fetchRemainingTrackRecords = async (access_token, startPage) => {
        try {
            setRemainingLoading(true);
            let currentPage = startPage;
            let remainingData = [];
            while (true) {
                const trackRecordsResponse = await axios.get(`https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records?page=${currentPage}&limit=${chunkSize}`, {
                    headers: {
                        Authorization: `Bearer ${access_token}`,
                    },
                });
                if (trackRecordsResponse.data.data.length === 0) break;
                remainingData = remainingData.concat(trackRecordsResponse.data.data);
                currentPage++;
            }
            const sortedData = remainingData.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            setData(prevData => prevData.concat(sortedData));
            setRemainingLoading(false);
        } catch (error) {
            console.error('Error fetching remaining track records:', error);
            setRemainingLoading(false);
        }
    };

    const fetchUpdatedTrackRecords = async () => {
        try {
            const access_token = await getAccessToken();

            // Fetch ALL pages so CSV has complete data
            let page = 1;
            const limit = chunkSize; // reuse existing chunk size (100)
            let aggregated = [];

            while (true) {
                const res = await axios.get(
                    `https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records?page=${page}&limit=${limit}`,
                    {
                        headers: { Authorization: `Bearer ${access_token}` },
                    }
                );
                const rows = (res.data && res.data.data) ? res.data.data : [];
                if (!rows.length) break;
                aggregated = aggregated.concat(rows);
                page += 1;
            }

            const sortedData = aggregated.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            setData(sortedData);
        } catch (error) {
            console.error('Error fetching updated track records:', error);
        }
    };

    useEffect(() => {
        const initialize = async () => {
            const access_token = await getAccessToken();
            await fetchInitialTrackRecords(access_token);
            await runPortfolio(access_token);
        };
        initialize();
    }, []);

    useEffect(() => {
        const updatePadding = () => {
            const screenWidth = window.innerWidth;
            const paddingValue = (0.86 * screenWidth - 275) / 20;
            document.documentElement.style.setProperty('--dynamic-padding', `${paddingValue}px`);
        };

        // Call the function initially to set the padding
        updatePadding();

        // Add event listener to handle window resize
        window.addEventListener('resize', updatePadding);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', updatePadding);
        };
    }, []);
    const runPortfolio = async (access_token) => {
        try {
            setMessage("trying to run backend portfolio");
            const trackRecordsResponse2 = await axios.get('https://max1-funding-arb.uc.r.appspot.com/run_portfolio', {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            });
            console.log('Portfolio response:', trackRecordsResponse2.data);
            const responseData = JSON.parse(trackRecordsResponse2.data.message);
            if (responseData.message === "Already running") {
                setMessage("The process is already running.");
                console.log("set message");
            } else if (responseData.message === "Data fetched and stored successfully") {
                setMessage("Updating data...");
                await fetchUpdatedTrackRecords();
                setMessage("Data updated.");
            } else {
                setMessage(responseData.message);
            }
        } catch (error) {
            console.error('Error running portfolio:', error);
            setMessage('Error running portfolio.');
        }
    };

    const handleDownload = async () => {
        try {
            // Fetch a fresh full dataset for CSV, with progress UI
            setIsDownloading(true);
            setDownloadPage(0);
            setDownloadTotalPages(0);
            // Allow the UI to render the progress state before heavy work
            await new Promise(resolve => setTimeout(resolve, 0));
            const access_token = await getAccessToken();
            let page = 1;
            const limit = 10000; // Ask backend for as many rows as possible in one call
            let aggregated = [];

            // First request to determine total pages
            const firstRes = await axios.get(
                `https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records?page=${page}&limit=${limit}`,
                { headers: { Authorization: `Bearer ${access_token}` } }
            );
            const firstRows = (firstRes.data && firstRes.data.data) ? firstRes.data.data : [];
            const totalRecords = firstRes.data && firstRes.data.total_records ? firstRes.data.total_records : undefined;
            const totalPages = totalRecords ? Math.ceil(totalRecords / limit) : undefined;
            if (totalPages) setDownloadTotalPages(totalPages);
            aggregated = aggregated.concat(firstRows);
            let completedPages = 1;
            setDownloadPage(completedPages);

            // If more pages, fetch them in parallel with limited concurrency
            if (totalPages && totalPages > 1) {
                const pages = Array.from({length: totalPages - 1}, (_, i) => i + 2);
                const concurrency = 6;
                let cursor = 0;

                const worker = async () => {
                    while (cursor < pages.length) {
                        const current = pages[cursor++];
                        const res = await axios.get(
                            `https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records?page=${current}&limit=${limit}`,
                            { headers: { Authorization: `Bearer ${access_token}` } }
                        );
                        const rows = (res.data && res.data.data) ? res.data.data : [];
                        if (rows.length) {
                            aggregated = aggregated.concat(rows);
                        }
                        completedPages += 1;
                        setDownloadPage(completedPages);
                    }
                };

                const workers = Array.from({length: Math.min(concurrency, pages.length)}, () => worker());
                await Promise.all(workers);
            } else if (!totalPages) {
                // Fallback: unknown total, continue sequentially (rare)
                page = 2;
                while (true) {
                    const res = await axios.get(
                        `https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records?page=${page}&limit=${limit}`,
                        { headers: { Authorization: `Bearer ${access_token}` } }
                    );
                    const rows = (res.data && res.data.data) ? res.data.data : [];
                    if (!rows.length) break;
                    aggregated = aggregated.concat(rows);
                    completedPages += 1;
                    setDownloadPage(completedPages);
                    page += 1;
                }
            }

            const sorted = aggregated.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            if (!sorted.length) return;

            const csv = jsonToCSV(sorted);
            const blob = new Blob([csv], {type: 'text/csv'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('hidden', '');
            a.setAttribute('href', url);
            a.setAttribute('download', 'track_records.csv');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (e) {
            console.error('Failed to download full Track Records CSV:', e);
        } finally {
            setIsDownloading(false);
            setDownloadPage(0);
            setDownloadTotalPages(0);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const paginatedData = data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

    // for loading page gray box
    const rows = 25;
    const cells = 10;

    // When page is still loading data, display gray box
    if (initialLoading) {
        return (
            <div className="container ">
                <div style={{marginTop: '7px'}}>
                    <ConnectWalletHeader
                        isAdminHeader={true}         // 传 true 就会显示你原先的 admin header（如果不需要就传false）
                        showPanel={showPanel}
                        setShowPanel={setShowPanel}
                    />
                </div>
                <div className="title-box d-flex justify-content-between align-items-center">
                    <img className="green-title" src={trackRecordIcon} alt=""></img>
                </div>
                {/*{message && <div className="alert alert-info noto">{message}</div>}*/}
                <div className="table-responsive noto">
                    <table className="table table-striped table-bordered mt-3">
                        <thead className="thead-dark">
                        <tr>
                            <th>Timestamp</th>
                            <th>Total Assets Value</th>
                            <th>Portfolio Expected APY</th>

                            <th>Portfolio Implied APR</th>
                            <th>Portfolio Expected 30 Days Earnings</th>

                            <th>Portfolio Implied 30 Days Earnings</th>
                            <th>Net Exposure Value</th>
                            <th>Money at Risk %</th>
                            <th>One Dollar Value Growth</th>
                            <th>Thirty Day Apy</th>
                            <th>Ninety Day Apy</th>
                            <th>USDI in Circulation</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Array.from({length: rows}).map((_, rowIndex) => (
                            <tr key={rowIndex} style={{borderBottom: "1px solid #FFFFFF1A"}}>
                                {Array.from({length: cells}).map((_, cellIndex) => (
                                    <td key={cellIndex}>
                                        <div className="gray-box"></div>
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <Footer>{message}</Footer>
            </div>
        );
    }

    return (
        <div className="container ">
            <div style={{marginTop: '7px'}}>
                <ConnectWalletHeader
                    isAdminHeader={true}         // 传 true 就会显示你原先的 admin header（如果不需要就传false）
                    showPanel={showPanel}
                    setShowPanel={setShowPanel}
                />
            </div>
            <TrackRecordsCheck></TrackRecordsCheck>
            <div className="title-box d-flex justify-content-between align-items-center">
                <img className="green-title" src={trackRecordIcon} alt=""></img>
            </div>
            <div className="table-responsive" style={{borderColor: "#1F464D"}}>
                <table className="table table-striped table-bordered mt-3">
                    <thead className="thead-dark">
                    <tr>
                        <th>Timestamp</th>
                        <th>Total Assets Value</th>
                        <th>Portfolio Expected APY</th>
                        <th>Portfolio Implied APR</th>
                        <th>Portfolio Expected 30 Days Earnings</th>

                        <th>Portfolio Implied 30 Days Earnings</th>
                        <th>Net Exposure Value</th>
                        <th>Money at Risk %</th>
                        <th>One Dollar Value Growth</th>
                        <th>Thirty Day Apy</th>
                        <th>Ninety Day Apy</th>
                        <th>USDI in Circulation</th>

                    </tr>
                    </thead>
                    <tbody>
                    {paginatedData.map((record, index) => (
                        <tr key={index}>
                            <td>{formatDate(record.timestamp.replace("GMT", ""))}</td>
                            <td>{formatToFourDigits(record.total_assets_value)}</td>
                            <td>{formatToPercentage(record.portfolio_expected_apr)}</td>
                            <td>{formatToPercentage(record.portfolio_implied_apr)}</td>
                            <td>{formatToFourDigits(record.portfolio_expected_30days_earnings)}</td>

                            <td>{formatToFourDigits(record.portfolio_implied_30days_earnings)}</td>
                            <td>{formatToFourDigits(record.net_exposure_value)}</td>
                            <td>{formatPercentage(record.money_at_risk_percent)}</td>
                            <td>{formatToFourDigits(record.dollar_value_growth)}</td>
                            <td>{formatPercentageAPY(record.thirty_day_apy)}</td>
                            <td>{formatPercentageAPY(record.ninety_day_apy)}</td>
                            <td>{formatUSDI(record.usdi_in_circulation)}</td>

                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            {remainingLoading && <div>Loading more data...</div>}
            <nav aria-label="Page navigation example" className="navbar-flexbox">
                <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link first" onClick={() => handlePageChange(1)}>First</button>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous
                        </button>
                    </li>
                    {Array.from({length: Math.min(4, Math.ceil(data.length / rowsPerPage))}, (_, i) => i + 1).map(page => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(page)}>{page}</button>
                        </li>
                    ))}
                    {Math.ceil(data.length / rowsPerPage) > 4 && (
                        <>
                            <li className="page-item disabled">
                                <span className="page-link">...</span>
                            </li>
                            <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'active' : ''}`}>
                                <button className="page-link"
                                        onClick={() => handlePageChange(Math.ceil(data.length / rowsPerPage))}>
                                    {Math.ceil(data.length / rowsPerPage)}
                                </button>
                            </li>
                        </>
                    )}
                    <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                    </li>
                    <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'disabled' : ''}`}>
                        <button className="page-link last"
                                onClick={() => handlePageChange(Math.ceil(data.length / rowsPerPage))}>Last
                        </button>
                    </li>
                </ul>
                <div className={styles.parent}>
                    <div className={styles.div}>「</div>
                    <div className={styles.downloadCsvParent}>
                        <div
                            onClick={isDownloading ? undefined : handleDownload}
                            className={styles.downloadCsv}
                            style={{opacity: isDownloading ? 0.6 : 1, cursor: isDownloading ? 'not-allowed' : 'pointer'}}
                        >
                            {isDownloading
                                ? (downloadTotalPages
                                    ? `Preparing CSV… (${downloadPage}/${downloadTotalPages})`
                                    : (downloadPage
                                        ? `Preparing CSV… (${downloadPage})`
                                        : 'Preparing CSV…'))
                                : 'Download CSV'}
                        </div>
                        <img className={styles.frameIcon} alt="" src={frameIcon}/>
                    </div>
                    <div className={styles.div1}>」</div>
                </div>
            </nav>
            <Footer>{message}</Footer>
        </div>
    );
};

export default TrackRecords;